let url = process.env.REACT_APP_BASE_URL;
let baseAPI = process.env.REACT_APP_BASE_URL + '/';
let originUrl = process.env.REACT_APP_MOTILAL_MF_MODULE_URL
console.log(url, '<--urlEndpoint-->', baseAPI)
export const endpoints = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    app: {
        init: `/init`
    },
    login: {
        generateOtp: '/login/generateOtp',
        verifyOtp: '/login/authenticateUser',
        logout: '/login/logout',
        common: `${baseAPI}login/common`,
        logout: '/logout',
        validateToken: '/validateToken',
        SETMPIN: "/c/login/SETMPIN",
        GenrateMPINOTPValidate: '/c/login/GenrateMPINOTPValidate'
    },
    preLogin: {
        fundDetail: `${baseAPI}FundDetail`,
        FundCategory: `${baseAPI}FundCategory`,
        FundCategoryNew: `${baseAPI}FundCategoryNew`,
        ETFFundCategory: `${originUrl}mutualfund/api/v1/ETFFundCategory`,
        // ETFFundCategory: 'http://localhost:8080/api/v1/ETFFundCategory',
        ETFApi: `${originUrl}mutualfund/api/v1/someFunc`,
        // ETFApi: 'http://localhost:8080/api/v1/someFunc',
        getAllFunds: `${originUrl}mutualfund/api/v1/getAllFunds`,
        // getAllFunds: `http://localhost:8080/api/v1/getAllFunds`,
        getFundsCategorisation: `${originUrl}mutualfund/api/v1/getFundsCategorisation`,
        // getFundsCategorisation: `http://localhost:8080/api/v1/getFundsCategorisation`,
    },
    ob: {
        masters: `${baseAPI}ob/getMasters`,
        common: `${baseAPI}ob/common`,
    },
    trans: {
        common: `${baseAPI}trans/common`,
        commonGet: `${baseAPI}trans/commonGet`,
        foliolist: `${originUrl}api/foliolist`,

    },
    checkCookies: `${baseAPI}chklogin`,
    orderbook: {
        GetLastFiveTran: '/c/orderbook/GetLastFiveTran'
    },
    etfTransaction: {
        createETFToken: "/c/etfTransaction/createETFToken",
        CreateTransactionID: "/c/etfTransaction/CreateTransactionID",
        GetTickerCode: "/c/etfTransaction/GetTickerCode",
        validatePath: "/validatePath",
    }
}